// Placeholder dossier for AARAV KRISHNA / PILOT-01
export const PILOT = {
  codename: "AARAV KRISHNA",
  designation: "PILOT-01",
  classification: "STUDENT DEVELOPER & ASPIRING ECONOMIST",
  status: "ACTIVE",
  syncRatio: 87.2,
  location: "TOKYO-3 // GEOFRONT SECTOR 7",
  birthRecord: "REDACTED",
  bloodType: "O+",
  tagline: "In the space between logic and imagination, I build.",
  socials: {
    github: "https://github.com/sniper-monke",
    linkedin: "https://linkedin.com/in/aarav-krishna",
    email: "aarav.krishna78@gmail.com",
    twitter: "https://twitter.com",
  },
  resumeUrl: "resume.pdf",
};

export const PERSONNEL_FILE = {
  biography:
    "Subject is a senior-year student working at the intersection of software systems and economic theory, guided not only by structure but by a strong creative and empathetic lens. Field reports suggest that they approach problems with curiosity and care—balancing first-principles thinking and modular design with an intuitive sense for human context, often uncovering insight in the quiet interactions between complex systems.",
  education: [
    { institution: "BOMBAY SCOTTISH SCHOOL- POWAI", role: "ICSE-SCIENCE", years: "2013-2025", note: "97.0% aggregate 10th boards. Top 1% national rank." },
    { institution: "BOMBAY SCOTTISH SCHOOL- MAHIM", role: "ISC- ECONOMICS+COMPUTER SCIENCE", years: "2025–2027", note: "Preparing for boards." },
    { institution: "PROJECTED // NUS SINGAPORE", role: "ECONOMICS+COMPUTER SCIENCE DOUBLE DEGREE", years: "ONGOING", note: "Application in transit." },
  ],
  interests: ["MECHANISM DESIGN", "OPEN-SOURCE SYSTEMS", "BEHAVIORAL ECONOMICS", "ECONOMIC THEORY", "MACROECONOMICS", "WEB DEVELOPMENT", "JAVA DEVLOPMENT"],
  hobbies: ["ARTISTRY", "MANGA COLLECTING", "BASKETBALL", "COOKING", "READING"],
  aspirations:
    "To build systems — code and policy alike — that compound human agency. Long-term: research economist with a tool-builder's hands; short-term: ship software that other students actually use.",
  personality: ["CURIOUS", "DELIBERATE", "PATIENT", "CREATIVE", "EMPATHETIC","INSIGHTFUL"],
  favoriteMedia: [
    "NEON GENESIS EVANGELION",
    "JOJO'S BIZARRE ADVENTURE",
    "OMNISCIENT READER'S VIEWPOINT",
    "ARCANE- LEAGUE OF LEGENDS",
    "GHOST IN THE SHELL (1995)",
    "TENET- CHRISTOPHER NOLAN",
  ],
  funFacts: [
    "Can cook whatever you want with near perfection",
    "Once debugged a deployment while having a 104 fever and nearly collapsing in school",
    "Owns wayyy too much manga that I've already read online",
    "LOVES fried chicken. More than anything in this world.",
    "Has watched End of Evangelion 9 times.",
  ],
};

export const PROJECTS = [
  {
    id: "OP-001",
    name: "MAGI: ECON SIMULATOR",
    classification: "STRATEGIC",
    summary: "Agent-based economic simulator modeling 10k consumers and 200 firms reaching market equilibrium under varying tax regimes.",
    tech: ["Python", "NumPy", "Mesa", "FastAPI", "React"],
    github: "https://github.com/aaravkrishna/magi-econ",
    demo: "#",
    image: "https://images.unsplash.com/photo-1640906152676-dace6710d24b?w=800&q=80",
    detail: "Implements heterogeneous-agent general equilibrium with Q-learning firms. Used by 3 university econ classes for policy what-ifs.",
  },
  {
    id: "OP-002",
    name: "AT-FIELD",
    classification: "INFRASTRUCTURE",
    summary: "Self-hosted personal firewall + DNS sinkhole running on a Raspberry Pi 5, blocking 2.1M tracker domains across a household network.",
    tech: ["Go", "Pi-hole", "WireGuard", "Docker"],
    github: "https://github.com/aaravkrishna/at-field",
    demo: "#",
    image: "https://images.unsplash.com/photo-1544631008-534b4b6c1215?w=800&q=80",
    detail: "Custom DNS-over-HTTPS resolver with rule scripting. Drops latency 22% vs ISP defaults.",
  },
  {
    id: "OP-003",
    name: "DOSSIER",
    classification: "TOOLING",
    summary: "Markdown-first second-brain CLI with bi-directional links, full-text search, and a graph viewer in the terminal.",
    tech: ["Rust", "ratatui", "sqlite"],
    github: "https://github.com/aaravkrishna/dossier",
    demo: "#",
    image: "https://images.unsplash.com/photo-1610219542098-df1753da93bc?w=800&q=80",
    detail: "300+ GitHub stars. Fully offline. Featured in a Rust newsletter.",
  },
  {
    id: "OP-004",
    name: "GEOFRONT",
    classification: "VISUALIZATION",
    summary: "WebGL map of the Delhi Metro that animates passenger flow against real GTFS schedules. Used for a class project on transit equity.",
    tech: ["TypeScript", "deck.gl", "GTFS"],
    github: "https://github.com/aaravkrishna/geofront",
    demo: "#",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&q=80",
    detail: "Animates 14M weekly trips on a single page. Won school innovation prize.",
  },
  {
    id: "OP-005",
    name: "EVA-UNIT-LATEX",
    classification: "CREATIVE",
    summary: "Opinionated LaTeX template engine that turns plain markdown into IB-quality economics IAs with auto-citation and a houseplant of charts.",
    tech: ["TypeScript", "LaTeX", "Pandoc"],
    github: "https://github.com/aaravkrishna/eva-latex",
    demo: "#",
    image: "https://images.unsplash.com/photo-1581090700227-1e37b190418e?w=800&q=80",
    detail: "Used by ~80 students across my school. Reduces formatting time by ~6 hours per essay.",
  },
  {
    id: "OP-006",
    name: "SHINJI",
    classification: "EXPERIMENTAL",
    summary: "Tiny chess engine written for the love of pain. Negamax + alpha-beta + transposition tables. Reaches ~2100 elo on lichess bots.",
    tech: ["C++", "SIMD", "CMake"],
    github: "https://github.com/aaravkrishna/shinji",
    demo: "#",
    image: "https://images.unsplash.com/photo-1529699211952-734e80c4d42b?w=800&q=80",
    detail: "Sub-millisecond evaluation per node. Built without copying any modern engine source.",
  },
];

export const SKILLS = {
  LANGUAGES: [
    { name: "JAVA", value: 92 },
    { name: "JAVASCRIPT", value: 88 },
    { name: "TYPESCRIPT", value: 71 },
    { name: "HTML/CSS", value: 65 },
    { name: "PYTHON", value: 60 },
    { name: "BOOLEAN LOGIC", value: 80 },
  ],
  FRAMEWORKS: [
    { name: "REACT / NEXT", value: 90 },
    { name: "FASTAPI", value: 85 },
    { name: "TAILWIND", value: 90 },

  ],
  TOOLS: [
    { name: "GIT / CI", value: 88 },
    { name: "DOCKER", value: 80 },
    { name: "LINUX SYSADMIN", value: 78 },
    { name: "FIGMA", value: 70 },
  ],
  CREATIVE: [
    { name: "ARTISTRY", value: 82 },
    { name: "RETRO PHOTOGRAPHY", value: 70 },
    { name: "COOKING ", value: 75 },
  ],
  RESEARCH: [
    { name: "MACROECONOMICS", value: 88 },
    { name: "GAME THEORY", value: 80 },
    { name: "ECONOMETRICS", value: 90 },
    { name: "LIT REVIEW", value: 78 },
  ],
};

export const ECONOMICS_ESSAYS = [
  {
    title: "ON THE PRICE OF AN IDEA",
    period: "ESSAY // 2024",
    summary: "An attempt to map information-goods to Bertrand competition when zero marginal cost meets nonzero attention cost.",
    tags: ["MICRO", "INFORMATION GOODS"],
  },
  {
    title: "SCHELLING'S TRAFFIC",
    period: "RESEARCH NOTE // 2024",
    summary: "Reproduces Schelling segregation on a Delhi commuter dataset. Finds emergent corridors that no planner drew.",
    tags: ["GAME THEORY", "URBAN"],
  },
  {
    title: "THE RUPEE & THE GRAPH",
    period: "COMPETITION // 2023",
    summary: "Won regional ASE Olympiad. Argues that India's UPI ecosystem is a public good with a private graph topology.",
    tags: ["MONETARY", "NETWORKS"],
  },
  {
    title: "RATIONAL ANGELS",
    period: "ESSAY // 2025",
    summary: "What if Akerlof's lemons could lie strategically? A toy model of bounded-rational adverse selection.",
    tags: ["BEHAVIORAL", "INFO-ASYMMETRY"],
  },
];

export const ACHIEVEMENTS = [
  { code: "REC-014", title: "OUTSTANDING PERFORMANCE ACHIEVEMENT-95%+ ", year: "2025" },
  { code: "REC-021", title: "PERSEVERANTIA TECHNICAL OPERATIONS HEAD", year: "2026" },
  { code: "REC-028", title: "SCOTTISH MODEL UNITED NATIONS TECH OPS HEAD", year: "2026" },
  { code: "REC-033", title: "Inter-House Dramatics- 1st Place", year: "2024" },
  { code: "REC-039", title: "BASKETBALL- 1x district level champion, 2x zonal level", year: "2023-2025" },
  { code: "REC-045", title: "Crowdfunding- Most funds raised for alleviating the unfortunate", year: "2023" },
];

export const ART_GALLERY = [
  { id: "ART-001", title: "REZE CHAINSAWMAN PORTRAIT", url: "/rezeportrait.jpeg" },
  { id: "ART-002", title: "PUCCI JJBA PARTE 6", url: "/pucci.jpeg" },
  { id: "ART-003", title: "DIO BRANDO JJBA PARTE 3", url: "/dio.jpeg" },
  { id: "ART-004", title: "REZE CHAINSAWMAN POSTER", url: "/reze poster.jpeg" },
  { id: "ART-005", title: "GIORNO GIOVANNA PARTE 5", url: "/giorno.jpeg" },
  { id: "ART-006", title: "GALLERY", url: "/gallery.jpeg" },
];

export const CURRENT_STATUS = [
  { label: "BUILDING", value: "an open-source budgeting tool for Indian students." },
  { label: "STUDYING", value: "Mas-Colell, Whinston & Green (Chapters 1–6)." },
  { label: "READING", value: "'The Worldly Philosophers' — R. Heilbroner." },
  { label: "LEARNING", value: "Rust async runtimes and tokio internals." },
  { label: "CREATING", value: "a poster series on Indian monsoon patterns." },
];

export const NERV_MEDIA = {
  nervLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/NERV_logo.svg/800px-NERV_logo.svg.png",
  seeleLogo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Seele_logo.svg/1024px-Seele_logo.svg.png",
  // Authentic Evangelion UI/title cards (user-provided + imgur album mvW7g)
  magiDeliberation: "https://customer-assets.emergentagent.com/job_nerv-archives-aarav/artifacts/h91tlhtk_image.png",
  harmonicsGraph: "https://customer-assets.emergentagent.com/job_nerv-archives-aarav/artifacts/umbz8vym_image.png",
  fourPanelHud: "https://customer-assets.emergentagent.com/job_nerv-archives-aarav/artifacts/g59l9ygp_image.png",
  episodeOneCard: "https://customer-assets.emergentagent.com/job_nerv-archives-aarav/artifacts/a1cp97p8_image.png",
  fui1: "https://i.imgur.com/TkOO9fF.jpg",
  fui2: "https://i.imgur.com/6mDPV0L.jpg",
  fui3: "https://i.imgur.com/ebxjA8x.jpg",
  // Character archive feeds (Giphy — animated loops for voice-log panels)
  characterRei: "https://media.giphy.com/media/UNPQQ6HvLb4w66KkI2/giphy.gif",
  characterAsuka: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ3ozbjNramF6N2F5d282a3h4cHhjb25uZTFhZW95enVsYmprMW9tdiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/cvEEwGaq86ZpjHnk49/giphy.gif",
  characterShinji: "https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExdm5kdnlpczc1Y252cW1sbjdueWd2ZWNpaWc2OWp3bnUwYjZ5b2ZsZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/bSgKBZKCxh8Iqlwxne/giphy.gif",
};

export const CHARACTER_MEDIA = {
  rei:    { src: NERV_MEDIA.characterRei,    alt: "Rei Ayanami — Neon Genesis Evangelion" },
  asuka:  { src: NERV_MEDIA.characterAsuka,  alt: "Asuka Langley Shikinami — Neon Genesis Evangelion" },
  shinji: { src: NERV_MEDIA.characterShinji, alt: "Shinji Ikari — Neon Genesis Evangelion" },
};

// Episode title cards interspersed between sections
export const EPISODES = {
  personnel:    { episode: "貳",   titleJp: "見知らぬ、天井", titleEn: "THE BEAST", subtitle: "PERSONNEL FILE // PILOT-01 DOSSIER" },
  operations:   { episode: "参",   titleJp: "鳴らない、電話", titleEn: "OPERATIONS LOG", subtitle: "PROJECT ARCHIVE // CONFIRMED HITS" },
  skills:       { episode: "肆",   titleJp: "雨、逃げ出した後", titleEn: "SYNC RATIO TEST", subtitle: "EVANGELION HARMONICS // CHANNEL A" },
  economics:    { episode: "伍",   titleJp: "レイ、心のむこうに", titleEn: "DIVISION-E", subtitle: "ECONOMIC ANALYSIS // SECTOR 7" },
  achievements: { episode: "陸",   titleJp: "決戦、第3新東京市", titleEn: "NERV RECORDS", subtitle: "DECISIVE BATTLE // TOKYO-3" },
  gallery:      { episode: "漆",   titleJp: "人の造りしもの", titleEn: "WORKS OF MAN", subtitle: "ART ARCHIVE // VISUAL EVIDENCE" },
  status:       { episode: "捌",   titleJp: "アスカ、来日",   titleEn: "CURRENT OPS", subtitle: "REAL-TIME PILOT TELEMETRY" },
  contact:      { episode: "玖",   titleJp: "瞬間、心、重ねて", titleEn: "OPEN CHANNEL", subtitle: "COMMS PIPE // ENCRYPTED" },
};

